export default "__VITE_ASSET__k88EDUgV__"